<template>
	<div>
		user...
	</div>
</template>

<script>
	export default {
		name:'user'
	}
</script>

<style>
</style>
